import { __decorate } from "tslib";
// Core
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
// Queries / Mutations
/**
 * <class>
 * @author Jan Canicon <jan@gorated.ph>
 *                     <jancanicon.work@gmail.com>
 * @since Version {x.xx.x}
 *
 * Docs: <url>
 */
let ListTransition = class ListTransition extends Vue {
    get enterClasses() {
        let animationName = null;
        if (this.enterClass === 'none') {
            return `${this.name}-enter-active`;
        }
        if (this.enterClass) {
            return `${this.name}-enter-active ${this.enterClass}`;
        }
        switch (this.enterDirection) {
            case 'up':
                animationName = 'fadeInUp';
                break;
            case 'down':
                animationName = 'fadeInDown';
                break;
            case 'left':
                animationName = 'fadeInLeft';
                break;
            case 'right':
                animationName = 'fadeInRight';
                break;
            default:
                animationName = 'fadeIn';
        }
        return `${this.name}-enter-active animated ${animationName}`;
    }
    get leaveClasses() {
        let animationName = null;
        if (this.leaveClass === 'none') {
            return `${this.name}-enter-active`;
        }
        if (this.leaveClass) {
            return `${this.name}-leave-active ${this.leaveClass}`;
        }
        switch (this.leaveDirection) {
            case 'up':
                animationName = 'fadeOutUp';
                break;
            case 'down':
                animationName = 'fadeOutDown';
                break;
            case 'left':
                animationName = 'fadeOutLeft';
                break;
            case 'right':
                animationName = 'fadeOutRight';
                break;
            default:
                animationName = 'fadeOut';
        }
        return `${this.name}-leave-active animated ${animationName}`;
    }
};
__decorate([
    Prop({ type: String, default: 'slider' })
], ListTransition.prototype, "name", void 0);
__decorate([
    Prop({ type: String, default: null })
], ListTransition.prototype, "tag", void 0);
__decorate([
    Prop({ type: String, default: null })
], ListTransition.prototype, "enterDirection", void 0);
__decorate([
    Prop({ type: String, default: null })
], ListTransition.prototype, "leaveDirection", void 0);
__decorate([
    Prop({ type: String, default: null })
], ListTransition.prototype, "enterClass", void 0);
__decorate([
    Prop({ type: String, default: null })
], ListTransition.prototype, "leaveClass", void 0);
ListTransition = __decorate([
    Component
], ListTransition);
export default ListTransition;
